import React, { useEffect, useState } from "react";
import api from "../../api/axios";

const SettingsSection = () => {
  const [form, setForm] = useState({
    company_name: "",
    opening_hours: "",
    email: "",
    telephone: "",
    mobile_no: "",
    address: "",
    facebook_link: "",
    instagram_link: "",
    youtube_link: "",
    tiktok_link: "",
    linkedin_link: "",
    is_active: false,
  });

  const [logo, setLogo] = useState(null);
  const [popupImage, setPopupImage] = useState(null);
  const [preview, setPreview] = useState({});

  useEffect(() => {
    api.get("companyblog/admin/company-settings/").then((res) => {
      if (res.data) {
        setForm(res.data);
        setPreview({
            logo: res.data.logo_image_url,
            popup: res.data.popup_image_url,
          });
      }
    });
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const normalizeUrl = (url) => {
  if (!url) return url;
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    return "https://" + url;
  }
  return url;
};

  const formData = new FormData();

  Object.entries(form).forEach(([key, value]) => {
  if (
    key !== "logo_image" &&
    key !== "popup_image" &&
    key !== "logo_image_url" &&
    key !== "popup_image_url"
  ) {
    if (value !== null && value !== undefined && value !== "") {
       if (key.endsWith("_link")) {
      value = normalizeUrl(value);
    }
      formData.append(key, value);
    }
  }
});

  if (logo) formData.append("logo_image", logo);
  if (popupImage) formData.append("popup_image", popupImage);

  await api.put("companyblog/admin/company-settings/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  alert("Company settings updated successfully");
};


  return (
    <form onSubmit={handleSubmit} className="card p-4">
      <h4 className="mb-3">Edit Master Settings</h4>

      <div className="row">
        <div className="col-md-6">
          <input
            className="form-control mb-3"
            name="company_name"
            placeholder="Company Name"
            value={form.company_name}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6">
          <input
            className="form-control mb-3"
            name="opening_hours"
            placeholder="Opening Hours"
            value={form.opening_hours}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6">
          <input
            className="form-control mb-3"
            name="email"
            value={form.email}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6">
          <input
            className="form-control mb-3"
            name="telephone"
            value={form.telephone}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6">
          <input
            className="form-control mb-3"
            name="mobile_no"
            value={form.mobile_no || ""}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-12">
          <textarea
            className="form-control mb-3"
            name="address"
            value={form.address}
            onChange={handleChange}
          />
        </div>

        {/* Social Links */}
        {[
          "facebook_link",
          "instagram_link",
          "youtube_link",
          "tiktok_link",
          "linkedin_link",
        ].map((field) => (
          <div className="col-md-6" key={field}>
            <input
              className="form-control mb-3"
              name={field}
              placeholder={field.replace("_", " ")}
              value={form[field] || ""}
              onChange={handleChange}
            />
          </div>
        ))}

        {/* Images */}
        <div className="col-md-6">
          <label>Logo</label>
          <input
            type="file"
            className="form-control"
            onChange={(e) => setLogo(e.target.files[0])}
          />
          {preview.logo && (
            <img src={preview.logo} alt="logo" width="120" className="mt-2" />
          )}
        </div>

        <div className="col-md-6">
          <label>Popup Image</label>
          <input
            type="file"
            className="form-control"
            onChange={(e) => setPopupImage(e.target.files[0])}
          />
          {preview.popup && (
            <img src={preview.popup} alt="popup" width="120" className="mt-2" />
          )}
        </div>

        <div className="col-md-12 mt-3">
          <input
            type="checkbox"
            name="is_active"
            checked={form.is_active}
            onChange={handleChange}
          />{" "}
          Is Popup Active
        </div>
      </div>

      <button className="btn btn-primary mt-4">Update</button>
    </form>
  );
};

export default SettingsSection;
